export class User {
    public id?: any;
    public email?: string;
    public activated?: Boolean;
    public academyCode?: string;
    public schoolUai?: string;
    public langKey?: string;
    public authorities?: any[];
    public createdBy?: string;
    public createdDate?: string;
    public lastModifiedBy?: string;
    public lastModifiedDate?: string;
    public password?: string;
    public academicRegionLabel?: string;
    public academyLabel?: string;
    public schoolLabel?: string;
    public schoolName?: string;
    public schoolLeader?: Boolean;
    public schoolAssignedMasters?: string[];
    public info?: string;
    public authoritiesString?: string;
    public campaign?: string;
    constructor(
        id?: any,
        email?: string,
        activated?: Boolean,
        academyCode?: string,
        schoolUai?: string,
        langKey?: string,
        authorities?: any[],
        createdBy?: string,
        createdDate?: string,
        lastModifiedBy?: string,
        lastModifiedDate?: string,
        password?: string,
        academicRegionLabel?: string,
        academyLabel?: string,
        schoolLabel?: string,
        schoolName?: string,
        schoolLeader?: Boolean,
        schoolAssignedMasters?: string[],
        info?: string,
        authoritiesString?: string,
        campaign?: string
    ) {
        this.id = id ? id : null;
        this.email = email ? email : null;
        this.activated = activated ? activated : false;
        this.academyCode = academyCode ? academyCode : null;
        this.schoolUai = schoolUai ? schoolUai : null;
        this.langKey = langKey ? langKey : null;
        this.authorities = authorities ? authorities : null;
        this.createdBy = createdBy ? createdBy : null;
        this.createdDate = createdDate ? createdDate : null;
        this.lastModifiedBy = lastModifiedBy ? lastModifiedBy : null;
        this.lastModifiedDate = lastModifiedDate ? lastModifiedDate : null;
        this.password = password ? password : null;
        this.academicRegionLabel = academicRegionLabel ? academicRegionLabel : null;
        this.academyLabel = academyLabel ? academyLabel : null;
        this.schoolLabel = schoolLabel ? schoolLabel : null;
        this.schoolName = schoolName ? schoolName : null;
        this.schoolLeader = schoolLeader ? schoolLeader : false;
        this.schoolAssignedMasters = schoolAssignedMasters ? schoolAssignedMasters : null;
        this.info = this.academicRegionLabel + ' - ' + academyLabel;
        this.authoritiesString = '';
        this.campaign = '';
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/user/user.model.ts